export const switchGroupDatapointName = 'SwitchGroup';
export const navigateFromMeToWeDatapointName = 'NavigateFromMeToWe';

// Group Header Usage datapoints
export const GroupHeaderSendEmailButtonClicked = 'GroupHeader_SendEmail_Button_Clicked';
export const GroupHeaderEmailButtonClicked = 'GroupHeader_Email_Button_Clicked';
export const GroupHeaderFilesButtonClicked = 'GroupHeader_Files_Button_Clicked';
export const GroupHeaderCalendarButtonClicked = 'GroupHeader_Calendar_Button_Clicked';
export const GroupHeaderNotebookButtonClicked = 'GroupHeader_Notebook_Button_Clicked';
export const GroupHeaderPlannerButtonClicked = 'GroupHeader_Planner_Button_Clicked';
export const GroupHeaderSiteButtonClicked = 'GroupHeader_Site_Button_Clicked';
export const GroupHeaderCustomLeaveGroupButtonClicked =
    'GroupHeader_CustomLeaveGroup_Button_Clicked';
export const GroupHeaderSettingsButtonClicked = 'GroupHeader_Settings_Button_Clicked';
